<template>
  <a-modal
    title="Generowanie raportu godzinowego"
    width="40vw"
    wrapClassName="modal-wrapper"
    v-model="visible"
    @ok="onSubmit"
    @cancel="closeModal"
    :confirm-loading="loading"
    :disabled="true"
  >
    <inner-form
      v-if="lecturerId"
      v-model="form"
      :errors="errors"
      @submit="onSubmit"
    />
    <template slot="footer">
      <a-button key="back" @click="closeModal">
        Anuluj
      </a-button>
      <a-button
        key="submit"
        :disabled="!formFilled"
        type="primary"
        :loading="loading"
        @click="onSubmit"
      >
        Pobierz raport
      </a-button>
    </template>
  </a-modal>
</template>
<script>
import InnerForm from './InnerForm'
import { Lecturer } from '@/api'

export default {
  components: {
    InnerForm
  },
  data() {
    return {
      visible: false,
      form: {},
      loading: false,
      errors: {},
      lecturerId: null,
      InnerForm
    }
  },
  methods: {
    onSubmit() {
      this.loading = true
      Lecturer.report({ lecturerId: this.lecturerId, params: this.form })
        .then(res => {
          this.downloadBlobResponse(res)
        })
        .finally(() => {
          this.loading = false
        })
    },
    openModal(lecturerId) {
      this.visible = true
      this.lecturerId = lecturerId
      this.form = {}
    },
    success() {
      this.closeModal()
      this.$emit('formSubmitted')
    },
    closeModal() {
      this.resetForm()
      this.visible = false
    },
    resetForm() {
      this.form = {}
      this.errors = {}
    }
  },
  computed: {
    formFilled() {
      return (
        this.lecturerId && this.form.timespan_after && this.form.timespan_before
      )
    }
  }
}
</script>
